<template>
  <q-dialog v-model="dialog">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{ title }}</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        {{ body }}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          rounded
          unelevated
          no-caps
          label="OK"
          color="secondary"
          @click.native="close"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
    title: String,
    body: String,
  },

  methods: {
    close() {
      this.dialog = false;
    },
  },
  computed: {
    dialog: {
      get() {
        return this.open;
      },
      set(value) {
        this.$emit("update:open", value);
      },
    },
  },
};
</script>
